module.exports = __webpack_public_path__ + "static/media/20201114_154834_846_IMG_9979.43bbcff4.jpg";